<template>
  <v-tooltip bottom v-if="tooltip">
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs" class="mr-2">
        <v-btn
          @click="$emit('click')"
          :to="to"
          :small="small"
          :loading="loading"
          icon
          :disabled="disabled"
          :class="{ 'outlined-button': outlined }"
          :color="color"
          :height="small ? '28px' : '36px'"
          :width="small ? '28px' : '36px'"
        >
          <v-icon :small="small" :large="large">{{ icon }}</v-icon>
        </v-btn>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>

  <v-btn
    v-else
    @click="$emit('click')"
    :to="to"
    :small="small"
    :loading="loading"
    icon
    :disabled="disabled"
    :class="{ 'outlined-button': outlined }"
    :color="color"
    :height="small ? '28px' : '36px'"
    :width="small ? '28px' : '36px'"
  >
    <v-icon :small="small" :large="large">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
import { tooltip } from "leaflet";

export default {
  props: {
    small: {
      type: Boolean,
      required: false,
      default: true,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "",
    },
    to: {
      type: [String, Object],
      required: false,
      default: undefined,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltip: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style scoped>
.outlined-button {
  border: 2px solid rgba(0, 0, 0, 0.12) !important;
  background-color: white !important;
}
</style>
